import React, { useState, useEffect } from "react";
import "../pagescss/CpuPlayer.css";
import Header from "../component.jsx/Header";
import { useNavigate } from "react-router-dom";


const CpuPlayer = () => {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [isPlayerTurn, setIsPlayerTurn] = useState(true);
  const [winner, setWinner] = useState(null);
  const Navigate = useNavigate();

  const handleback = () => {
    Navigate(-1);
  };

  const checkWinner = (squares) => {
    const lines = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [2, 4, 6],
    ];
    for (let line of lines) {
      const [a, b, c] = line;
      if (
        squares[a] &&
        squares[a] === squares[b] &&
        squares[a] === squares[c]
      ) {
        return squares[a];
      }
    }
    return null;
  };

  const handleClick = (index) => {
    if (board[index] || winner) return;
    const newBoard = board.slice();
    newBoard[index] = "X";
    setBoard(newBoard);
    setIsPlayerTurn(false);
  };

  const cpuMove = () => {
    const availableMoves = board
      .map((val, idx) => (val === null ? idx : null))
      .filter((val) => val !== null);
    const randomMove =
      availableMoves[Math.floor(Math.random() * availableMoves.length)];
    const newBoard = board.slice();
    newBoard[randomMove] = "O";
    setBoard(newBoard);
    setIsPlayerTurn(true);
  };

  useEffect(() => {
    const winner = checkWinner(board);
    if (winner) {
      setWinner(winner);
    } else if (!isPlayerTurn && !winner) {
      const timer = setTimeout(cpuMove, 500); // CPU move after a delay
      return () => clearTimeout(timer);
    }
  }, [board, isPlayerTurn]);

  const resetGame = () => {
    setBoard(Array(9).fill(null));
    setIsPlayerTurn(true);
    setWinner(null);
  };

  return (
    <div className="container-game">
      <Header />
      <button onClick={handleback} className="back-btn">
        Back
      </button>

      <div className="top-buttons">
        {winner ? (
          <div className="game-status">
            <h2 className="status-text-winner-cpu">
              {winner === "X" ? "Player Wins!" : "CPU Wins!"}
            </h2>
          </div>
        ) : (
          <div className="game-status">
            <h2>{isPlayerTurn ? "Your Turn (X)" : "CPU Turn (O)"}</h2>
          </div>
        )}
        <button className="reset-button" onClick={resetGame}>
          Play Again
        </button>
      </div>
      <div className="cpu-player-container">
        <div className="game-board">
          {board.map((value, index) => (
            <div
              key={index}
              className="game-square"
              onClick={() => handleClick(index)}
            >
              {value ? (
                value
              ) : (
                <img className="logo-gamenow-placeholder" src="https://casual.gamenow.com.pk/assets/images/logo%20(1).png" alt="Game-Now"></img>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CpuPlayer;
